var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.5 11a1 1 0 0 1 1-1h38a1 1 0 0 1 1 1v58a1 1 0 0 1-1 1h-38a1 1 0 0 1-1-1V54a1 1 0 1 1 2 0v14h36V12h-36v14a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M37.694 25.086a1 1 0 0 1 1.076.172l14.4 13a1 1 0 0 1 0 1.484l-14.4 13A1 1 0 0 1 37.1 52v-6.8H10.5a1 1 0 0 1-1-1V33.8a1 1 0 0 1 1-1h26.6V26a1 1 0 0 1 .594-.914M39.1 28.25v5.55a1 1 0 0 1-1 1H11.5v8.4h26.6a1 1 0 0 1 1 1v5.55L51.008 39z",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;